import clsx from 'clsx';

/**
 * Properties for the BadgeV1 component.
 */
interface IBadgeProps {
  /** Optional CSS class name for the badge. */
  className?: string;
  /** The text content to display within the badge. */
  children: string;
  /** The status type of the badge, determining its visual style. */
  type: 'In Review' | 'Approved' | 'Rejected';
}

/**
 * -----------------------------------------------------------------------------
 * It renders a tag with white text and gray background.
 * @deprecated This component is being replaced by the new ui/badge component.
 */
export function BadgeV1({ children, className, type }: Readonly<IBadgeProps>) {
  return (
    <div
      className={clsx(
        'rounded-full bg-gray-400 px-3 py-1 text-xs font-medium',
        className,
        type === 'In Review'
          ? 'border-primary-500 bg-primary-300/60 text-primary-600 border'
          : '',
        type === 'Approved'
          ? 'border border-green-500 bg-green-300/60 text-green-600'
          : '',
        type === 'Rejected'
          ? 'border border-red-500 bg-red-300/60 text-red-800'
          : ''
      )}
    >
      {children}
    </div>
  );
}
